import { render, staticRenderFns } from "./FTab.vue?vue&type=template&id=2b68b503&scoped=true&"
import script from "./FTab.vue?vue&type=script&lang=js&"
export * from "./FTab.vue?vue&type=script&lang=js&"
import style0 from "./FTab.vue?vue&type=style&index=0&id=2b68b503&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b68b503",
  null
  
)

export default component.exports